import { cn } from "@/lib/utils";

const PUSH_BADGE = {
  added: {
    label: "Added",
    className: "bg-mui-success-surface text-mui-success-ink border-mui-success-border",
  },
  removed: {
    label: "Removed",
    className: "bg-mui-error-surface text-mui-error-ink border-mui-error-border",
  },
} as const;

/**
 * The push preview's Added / Removed pill (#1090; #1049 R5, R6): a row or
 * group the push adds or removes says so under its name, in words, not in
 * colour alone.
 */
export function PushBadge({ kind }: { kind: "added" | "removed" }) {
  const { label, className } = PUSH_BADGE[kind];
  // A block around an inline block: a struck row's decoration reaches neither.
  return (
    <span className="mt-1 block leading-none">
      <span
        data-testid="push-badge"
        className={cn(
          "inline-flex h-5 w-fit items-center rounded-full border border-solid px-2 text-[0.75rem] leading-none font-medium",
          className,
        )}
      >
        {label}
      </span>
    </span>
  );
}
